import { render, staticRenderFns } from "./Step7Attachments.vue?vue&type=template&id=756edb34&scoped=true"
import script from "./Step7Attachments.vue?vue&type=script&lang=js"
export * from "./Step7Attachments.vue?vue&type=script&lang=js"
import style1 from "./Step7Attachments.vue?vue&type=style&index=1&id=756edb34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756edb34",
  null
  
)

export default component.exports